import { render, staticRenderFns } from "./JoeyLoading.vue?vue&type=template&id=496c2db2"
import script from "./JoeyLoading.vue?vue&type=script&lang=ts"
export * from "./JoeyLoading.vue?vue&type=script&lang=ts"
import style0 from "./JoeyLoading.vue?vue&type=style&index=0&id=496c2db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports